/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type ExportHistoryItemSchemaStatus = typeof ExportHistoryItemSchemaStatus[keyof typeof ExportHistoryItemSchemaStatus];


export const ExportHistoryItemSchemaStatus = {
  pending: 'pending',
  processing: 'processing',
  ready: 'ready',
  failed: 'failed',
} as const;
